module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/Card/components/Stat/images/battles.e51ebfee.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Stat/images/battles.png
// module id = 3124
// module chunks = 11